<template>
    <div class="container feedback template-bg-gray my-position-relative">
        <md-card class="request-status loop_container bg-transparent update-request-form-common">
            <md-card-content class="col-lg-12 col-md-12 col-sm-12 col-xs-12 main">
                <div class="card form-wrapper text-center p-20">
                    <h4 class="template-custom-title" v-if="!message.length">checking...</h4>
                    <h4 class="template-custom-title" else>{{message}}</h4>
                </div>
            </md-card-content>
        </md-card>
    </div>
</template>

<script>
import API from "../services/API";
export default {
    name: 'RequestEscalate',
    props: ['ask_id'],
    data() {
        return {
            fullPage: true,
            api: new API(),
            message: ''
        }
    },
    beforeCreate() {
        if (!this.$route.query.askid) {
            this.$router.push('/');
        }
    },
    async created() {
        await this.api.get(`asks/${this.$route.query.askid}`).then(async ask => {
            if (ask.data && ask.data.status !== '(7) Closed' && ask.data.status !== '(8) Closed') {
                await this.api.post(`asks/${this.$route.query.askid}/super-user-request-escalate`).then(response => {
                    this.message = 'Request has been escalated.';
                });
            } else {
                this.message = 'Something went wrong';
            }
        }).catch(err => {
            console.log('err', err);
            this.$toast.error('Something went wrong');
        });
    }
}
</script>



// WEBPACK FOOTER //
// src/components/RequestEscalate.vue